var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ripeav-base"},[_c('rl-header'),_c('div',{staticClass:"all"},[_c('router-view')],1),_c('rl-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }